(function ($) {
	$(document).ready(function () {

		// For each instance of the Social Slider.
		$.each($('.full-width-post-slider'), function () {

			$(this).slick(
				'slickSetOption',
				{
					infinite: false,
					variableWidth: true,
					responsive: [
						{
							breakpoint: 1200,
							settings: {
								variableWidth: false,
							}
						}
					]
				},
				true
			);

		});

	});
})(jQuery);
